import { css } from '@emotion/react'

export const CodeBlockStyle = css`


    .diffNewLine {
        color: #22863a;
        background-color: #f0fff4;
    }
  
    .diffRemoveLine {
        color: red;
        background-color: #ffcccc;
    }

`


export const SimpleCodeBlockStyle = css`
    padding: 2px 4px;
    color: #1f1f1f;

    border-radius: 4px;

    pre{
        background-color: rgb(38, 27, 44);
        padding: 10px;
        color: rgb(245, 242, 248);
    }

`



